<template>
    <div class="h-next-top-navigation w-full">
        <div class="hidden max-w-screen-2xl m-auto md:grid grid-cols-3 lg:grid-cols-6 h-full">
            <!-- <TopNavigationButton
                icon-class="icon-crm"
                :to="{name:'Dashboard'}"
                is="router-link"
                :active="isActive === 'crm'"
            >CRM
            </TopNavigationButton> -->
            <TopNavigationButton
            href="https://nextyu-qaprod.nextgroup.eu/" target="_blank" icon-class="icon-foo">
                CRM
            </TopNavigationButton>
            <TopNavigationButton
                icon-class="icon-contatto"
                href="https://nextyu-qaprod.nextgroup.eu/suppliers/" target="_blank"

            >ALBO FORNITORI
            </TopNavigationButton>
            <TopNavigationButton
                icon-class="icon-catena_orizzontale"
                :is="'router-link'"
                :to="{name:'ListaProgetti'}"
                :active="isActive === 'prj'"
            >PROGETTI
            </TopNavigationButton>
            <TopNavigationButton
                icon-class="icon-timesheet"
                href="https://nextyu-qaprod.nextgroup.eu/timesheet/" target="_blank"
            >TIMESHEET
            </TopNavigationButton>
            <TopNavigationButton
                icon-class="icon-catena_verticale"
                is="a"
                target="_blank"
                href="https://profilo.sistemi.com/Account/Login?ReturnUrl=%2Fwsfed%2Fcallback%3Fwa%3Dwsignin1.0%26wtrealm%3Dhttps%253A%252F%252Fjobrisorse.sistemi.com%252F%26wctx%3Drm%253D0%2526id%253Dpassive%2526ru%253D%25252f"
            >Gestione HR
            </TopNavigationButton>
            <TopNavigationButton
                icon-class="icon-tre_rettangoli"
                is="a"
                target="_blank"
                href="https://grupponext.sharepoint.com/sites/documenti_intranet/Documenti/Forms/AllItems.aspx"
            >Documenti
            </TopNavigationButton>
            <!--            <TopNavigationButton icon-class="icon-note_spesa" :to="{name:'ListaProgetti'}" :active="isActive === '2'">NOTE SPESA</TopNavigationButton>-->
            <!--            <TopNavigationButton icon-class="icon-ferie_permessi" :to="{name:'ListaProgetti'}" :active="isActive === '3'">FERIE E PERMESSI</TopNavigationButton>-->
        </div>
        <div class="m-auto md:hidden h-full flex justify-end pr-3">
            <input v-model="open" id="menu-toggle" type="checkbox" />
            <label class='menu-button-container' for="menu-toggle">
                <div class='menu-button'></div>
            </label>
            <ul class="menu">
                <li>
                    <TopNavigationButton
                        icon-class="icon-crm"
                        :to="{name:'Timesheet'}"
                        is="router-link"
                        :active="isActive === 'tim'"
                        class="w-full"
                        >
                        Timesheet
                    </TopNavigationButton>
                </li>
            </ul>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import TopNavigationButton from "@/components/TopNavigationButton.vue";
import env from "../Environment";

@Options({
    name: 'TopNavigationBar',
    components: {
        TopNavigationButton
    },
    props: {},
    watch: {
        '$route' () {
            this.open = false
        }
    }
})
export default class TopNavigationBar extends Vue {
    env = env
    get isActive() {
        //@ts-ignore
        return this.$route.meta.app
    }

    open = false
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.menu {
    display: flex;
    flex-direction: row;
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.menu > li {
    margin: 0 1rem;
    overflow: hidden;
}

.menu-button-container {
    display: none;
    height: 100%;
    width: 30px;
    cursor: pointer;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

#menu-toggle {
    display: none;
}

.menu-button,
.menu-button::before,
.menu-button::after {
    display: block;
    background-color: #fff;
    position: absolute;
    height: 4px;
    width: 30px;
    transition: transform 400ms cubic-bezier(0.23, 1, 0.32, 1);
    border-radius: 2px;
}

.menu-button::before {
    content: '';
    margin-top: -8px;
}

.menu-button::after {
    content: '';
    margin-top: 8px;
}

#menu-toggle:checked + .menu-button-container .menu-button::before {
    margin-top: 0px;
    transform: rotate(405deg);
}

#menu-toggle:checked + .menu-button-container .menu-button {
    background: transparent;
}

#menu-toggle:checked + .menu-button-container .menu-button::after {
    margin-top: 0px;
    transform: rotate(-405deg);
}


.menu-button-container {
    display: flex;
}
.menu {
    position: absolute;
    top: 0;
    margin-top: calc(var(--top-navigation-height));
    left: 0;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    align-items: center;
}
#menu-toggle ~ .menu li {
    height: 0;
    margin: 0;
    padding: 0;
    border: 0;
    transition: height 400ms cubic-bezier(0.23, 1, 0.32, 1);
}
#menu-toggle:checked ~ .menu li {
    border: 1px solid #333;
    height: 2.5em;
    transition: height 400ms cubic-bezier(0.23, 1, 0.32, 1);
}
.menu > li {
    display: flex;
    justify-content: center;
    margin: 0;
    padding: 0.5em 0;
    width: 100%;
    color: white;
    background-color: #222;
}
.menu > li:not(:last-child) {
    border-bottom: 1px solid #444;
}
</style>
